import React from 'react'
import FooterTailwind from 'TailwindcssComponents/Footer'
import TailwindLayout from 'TailwindcssComponents/TailwindLayout'
import TopBar from 'TailwindcssComponents/TopBar'
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

export default function VerifyEmail() {

    const bearerToken = localStorage.getItem('token');
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    const params = new URLSearchParams(useLocation().search);

    const sendVerification = async () => {
        try {
            const response = await axios.post(`${apiUrl}auth-service/auth/send-email-verification`, {}, {
                headers: { 'Authorization': `Bearer ${bearerToken}` },
            });
            if (response.data?.success) {
                toast.info(response.data.message || 'Verification Email sent successfully');
                navigate(`/verifyToken?token=${params.get('token')}&name=${params.get('name')}&orgName=${params.get('orgName')}`);
                // setTimeout(() => {
                // }, 500);
            } else {
                throw new Error("Failed to send email verification");
            }
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
        }
        // finally {
        //     setTimeout(() => {
        //         navigate('/dashboard');
        //     }, 1500);
        // }
    };

    return (
        <TailwindLayout>
            <TopBar />
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="max-w-md w-full p-8 bg-white rounded-lg shadow-md">
                    <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Email Verification</h2>
                    <p className="text-gray-600 mb-6 text-center">
                        Click the button below to receive a verification email
                    </p>
                    <div className="flex justify-center">
                        <button
                            onClick={() => sendVerification()}
                            className="px-6 py-2 bg-blue-600 text-white font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors"
                        >
                            Send Verification Email
                        </button>
                    </div>
                </div>
            </div>
            <FooterTailwind />
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </TailwindLayout>
    )
}
